import type { EntityConfig } from '../types'

export const applicationEntity: EntityConfig = {
  id: 'application',
  displayName: 'Application',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'pending_review', label: 'Pending Review' },
      { value: 'under_review', label: 'Under Review' },
      { value: 'approved', label: 'Approved' },
      { value: 'rejected', label: 'Rejected' },
      { value: 'returned', label: 'Returned' },
      { value: 'expired', label: 'Expired' },
    ],
    options: [
      { value: 'pending_review', label: 'Pending Review', color: 'warning' },
      { value: 'under_review', label: 'Under Review', color: 'info' },
      { value: 'approved', label: 'Approved', color: 'success' },
      { value: 'rejected', label: 'Rejected', color: 'error' },
      { value: 'returned', label: 'Returned', color: 'warning' },
      { value: 'expired', label: 'Expired', color: 'error' },
    ],
    mappings: {
      all: [],
      pending_review: ['pending_review'],
      under_review: ['under_review'],
      approved: ['approved'],
      rejected: ['rejected'],
      returned: ['returned'],
      expired: ['expired'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    country: { type: 'string_array', urlKey: 'country' },
    type: { type: 'string_array', urlKey: 'type' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
